module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "subcat-row"
  }, [_c('div', {
    staticClass: "subcat-row-label",
    attrs: {
      "tabindex": "0",
      "role": "button"
    },
    on: {
      "click": _vm.toggleIndicators,
      "keyup": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.toggleIndicators($event)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "space", 32)) { return null; }
        _vm.toggleIndicators($event)
      }]
    }
  }, [_c('span', [_c('i', {
    staticClass: "fa",
    class: _vm.iconClass
  })]), _vm._v(" "), _c('span', {
    staticClass: "current-subcat-title"
  }, [_vm._v(_vm._s(_vm.subcategory.name))])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "collapse"
    }
  }, [_c('indicator-block', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showIndicators),
      expression: "showIndicators"
    }],
    attrs: {
      "indicators": _vm.subcategory.indicators,
      "indicatorsColumnA": _vm.subcatColumnA.indicators,
      "indicatorsColumnB": _vm.subcatColumnB.indicators,
      "showIndicators": _vm.showIndicators
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-792f1782","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/comparison/CurrentSubcatRow.vue
// module id = 553
// module chunks = 1